export const PERMISSION_ACCESS = `access`;
export const PERMISSION_CREATE = `create`;
export const PERMISSION_READ = `read`;
export const PERMISSION_UPDATE = `update`;
export const PERMISSION_DELETE = `delete`;

export const PERMISSION_ACCESS_ALL = PERMISSION_ACCESS + `_all`;
export const PERMISSION_CREATE_ALL = PERMISSION_CREATE + `_all`;
export const PERMISSION_READ_ALL = PERMISSION_READ + `_all`;
export const PERMISSION_UPDATE_ALL = PERMISSION_UPDATE + `_all`;
export const PERMISSION_DELETE_ALL = PERMISSION_DELETE + `_all`;
